<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<ng-container *ngIf="products$ | async as products">
  <div
    *ngIf="products.length > 0"
    lazyLoad
    (lazyLoad)="onFirstView()">
    <idt-common-styles-render
      *ngIf="piece"
      [styles]="piece.settings?.styles">

      <header
        *ngIf="piece && showSliderHeader"
        class="slider-title">

        <render-wysiwyg
          *ngIf="piece.settings?.general?.showTitle
            && piece.settings?.general?.textGridTitle !== null"
          [piece]="piece"
          [html]="piece.settings?.general?.textGridTitle"
          [textPaddingTop]="piece.settings?.general?.textTitlePadding?.textPaddingTop"
          [textPaddingBottom]="piece.settings?.general?.textTitlePadding?.textPaddingBottom"
          [textPaddingLeft]="piece.settings?.general?.textTitlePadding?.textPaddingLeft"
          [textPaddingRight]="piece.settings?.general?.textTitlePadding?.textPaddingRight">
        </render-wysiwyg>

        <ng-container
          *ngIf="arrowPosition === 'header-right';
          then sliderArrows">
        </ng-container>

      </header>
      <div
        class="carousel-wrapper"
        role="region"
        tabindex="0"
        [attr.aria-label]="piece?.settings?.accessibility?.titleText"
        (keydown)="onKeyDown($event)">
        <div
          *ngIf="products"
          #swiper
          cmsSwiper
          aria-live="polite"
          class="swiper-container"
          [ngClass]="{ 'swiper-container-multirow': gridSize.numberOfRows > 1 }"
          [config]="swiperConfig">
          <div class="swiper-wrapper">
            <div
              *ngFor="let product of products; let index = index; trackBy: trackByProduct"
              class="swiper-slide"
              role="group"
              tabindex="0"
              aria-roledescription="slide">
              <div
                class="product-card">
                <div
                  class="image-product">
                  <render-link
                    class="image-link-product"
                    [lang]="lang"
                    [link]="getProductLink(product, index)"
                    (renderLinkEvent)="onProductLinkClick(product, index)">
                    <img
                      *ngIf="getProductImageData(product); let imageData"
                      alt="{{ product.name ?? '' }}"
                      [class]="imageClass"
                      [lazySrc]="imageData"/>
                  </render-link>
                  <render-product-purchase-options
                    *ngIf="isVisibleCart()"
                    [ngClass]="isMobile ? 'product-sizes-mobile' : 'product-sizes'"
                    [product]="product"
                    [country]="country"
                    [lang]="lang"
                    [piece]="piece">
                  </render-product-purchase-options>
                </div>
                <div
                  *ngIf="isVisibleName() || isVisiblePrice() || isVisibleButtonLink()"
                  class="product-data">
                  <render-product-colors
                    *ngIf="isVisibleColors()"
                    class="product-colors"
                    [product]="product"
                    [lang]="lang"
                    [piece]="piece">
                  </render-product-colors>
                  <div
                    class="product-container">
                    <render-wysiwyg
                      *ngIf="isVisibleName()"
                      class="product-name"
                      [html]="getTextProductName(product.name)"
                      [piece]="piece">
                    </render-wysiwyg>
                  </div>
                  <render-product-prices
                    *ngIf="isVisiblePrice()"
                    [product]="product"
                    [piece]="piece">
                  </render-product-prices>
                  <render-link
                    *ngIf="isVisibleButtonLink()"
                    class="button-link-product"
                    [lang]="lang"
                    [link]="getProductLink(product, index)">
                    <render-wysiwyg
                      [html]="piece.settings?.general?.textButtonLink"
                      [piece]="piece"
                      [textPaddingTop]="piece.settings?.general?.textPaddingTop"
                      [textPaddingBottom]="piece.settings?.general?.textPaddingBottom"
                      [textPaddingLeft]="piece.settings?.general?.textPaddingLeft"
                      [textPaddingRight]="piece.settings?.general?.textPaddingRight">
                    </render-wysiwyg>
                  </render-link>
                </div>
              </div>
            </div>
            <div class="swiper-pagination"></div>
          </div>
        </div>

        <render-modal-panel
          aria-labelledby="product-size-modal"
          #productSizeModal="render-modal-panel"
          [modalName]="'size-selector-modal-' + piece.id"
          [modalType]="'full'"
          [hasToShowCloseButton]="false"
        >
          <render-product-sizes-modal
            [props]="productSizeModal.props$ | async"
            *ngIf="productSizeModal.open">
          </render-product-sizes-modal>
        </render-modal-panel>

        <ng-container
          *ngIf="arrowPosition === 'inside-left-right';
          then sliderArrows">
        </ng-container>
      </div>
    </idt-common-styles-render>
  </div>

  <ng-template #sliderArrows>
    <div
      *ngIf="displayComponentArrows && isScrollPager"
      class="component-arrows arrow-control">
      <button
        (click)="arrowClick('prev')"
        class="arrow-left"
        [attr.aria-label]="piece?.settings?.accessibility?.previousText"
        tabindex="0"
        [disabled]="isFirstSlide">
        <svg
          class="swiper-arrow"
          viewBox="0 0 11 16"
          fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.82242 8L10.6154 14.532L9.08879 16L0.769231 8L9.08879 -8.65753e-07L10.6154 1.46796L3.82242 8Z" />
        </svg>
      </button>
      <button
        (click)="arrowClick('next')"
        class="arrow-right"
        [attr.aria-label]="piece?.settings?.accessibility?.nextText"
        tabindex="0"
        [disabled]="isLastSlide">
        <svg
          class="swiper-arrow"
          viewBox="0 0 11 16"
          fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6.79296 8L0 1.46796L1.5266 0L9.84615 8L1.5266 16L0 14.532L6.79296 8Z" />
        </svg>
      </button>
    </div>
  </ng-template>
</ng-container>
